import React from "react";
import '../components/Home.css';
import pdf from '../image/Ahmed Elbastawesy (Frontend Developer).pdf';
import image from '../image/my-sora.png'
import { FaDownload } from "react-icons/fa";
import Typed from 'typed.js';



function Home (){
  const el = React.useRef(null);

  React.useEffect(() => {
    const typed = new Typed(el.current, {
      strings: ['React JS', 'Redux', 'TypeScript'],
      typeSpeed: 50,
      backSpeed: 50,
      loop:true,
    });

    return () => {
      // Destroy Typed instance during cleanup to stop animation
      typed.destroy();
    };
  }, []);

    return(
      <>
        <div className="home flex justify-between items-center  text-white">
          <div className="my m-5">
           <div className="welcome flex items-center ">
            <p className=" text-2xl m-2">Welcome To My Website</p>
            <img src="https://raw.githubusercontent.com/sjabiulla/sjabiulla/main/wave.gif" alt="" className=" w-10" />
           </div>
           <div className="name ">
            <div className="elbasta">
            <h1 className=" text-5xl  m-2 text-[#4db5ff]">Hi, I'm Ahmed <span className="hed2 text-4xl">ELBastawesy</span></h1>
            </div>
            <p className="text-2xl m-3">Front-End <span className="text-[#4db5ff]">&</span> Cross Platform Developer </p>
            <div className="typing">
              <span ref={el} className=" m-2 text-[#4db5ff] text-3xl"></span>
            </div>
            <a href={pdf} download className="m-3 bg-gradient-to-r from-cyan-500 to-[#3b82f652]">Download CV <FaDownload className=" m-1"/></a>
           </div>
          </div>
          <div className="image mr-10">
            <div className="sora bg-gradient-to-r from-cyan-500 to-[#3b82f652]">
              <img src={image} alt="" />
            </div>
          </div>
        </div>
      </>
    )
}

export default Home;
